import { SubscriptionAire, SubscriptionBirth } from 'shell/authorizations/subscription';
import { NotFound } from 'shell/error/components/error-not-found';
import SubscriptionBirthPage from 'subscription/pages/registration-birth-family';
import SubscriptionBirthCohabitationPage from 'subscription/pages/registration-birth-cohabitation';
import FamilyPage from 'subscription/pages/registration-birth-family/search';
import FamilyPageCohabitation from 'subscription/pages/registration-birth-cohabitation/search';
import HomePage from 'subscription/pages/home';
import WrapperPersonSearch from 'shell/components/shared/person-search/wrapper-person-search';
import BornSolo from 'subscription/pages/transcription-birth-act-lonely';
import BornAggregazioneSearch from 'subscription/pages/transcription-birth-act-family-aggregation/search';
import BornAggregazione from 'subscription/pages/transcription-birth-act-family-aggregation';
import TransferNewSearch from 'subscription/pages/transfer-other-municipality-new-family/search';
import TransferNew from 'subscription/pages/transfer-other-municipality-new-family';
import TransferAggregationSearch from 'subscription/pages/transfer-other-municipality-family-aggregation/search';
import TransferAggregation from 'subscription/pages/transfer-other-municipality-family-aggregation';
import CitizenshipAggregationSearch from 'subscription/pages/gain-citizenship-family-aggregation/search';
import CitizenshipAggregation from 'subscription/pages/gain-citizenship-family-aggregation';
import PageResearchNotificationsInitizializer from 'shell/components/shared/research-notifications';
import { Outlet } from 'react-router-dom';
import ResearchFamilyNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/family';
import ResearchFamilyNotificationsDetailPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/family/detail';
import ResearchFamilyNotificationsMotherPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/mother';
import ResearchFamilyNotificationsMotherDetailPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/mother/detail';
import ResearchFamilyNotificationsFatherPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/father';
import ResearchFamilyNotificationsFatherDetailPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/father/detail';
import ResearchFamilyNotificationsOtherPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/other';
import ResearchFamilyNotificationsOtherDetailPage from 'subscription/pages/research-registration-civil-status-registry-office/research-family/other/detail';
import ResearchCohabitationNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-cohabitation';
import ResearchCohabitationNotificationsDetailPage from 'subscription/pages/research-registration-civil-status-registry-office/research-cohabitation/detail';
import ResearchDeathNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-death';
import CancellationDeathNotificationPage from 'subscription/pages/research-registration-civil-status-registry-office/research-death/detail';
import ResearchMarriageNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-marriage';
import ResearchMarriageDetailNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-marriage/detail';
import CitizenshipNew from 'subscription/pages/gain-citizenship-new-family';
import PersonSipoPage from 'subscription/pages/gain-citizenship-family-aggregation/edit-person';
import PersonSipoCitizenshipNewPage from 'subscription/pages/gain-citizenship-new-family/edit-person';
import PersonSipoTransferNewPage from 'subscription/pages/transfer-other-municipality-new-family/edit-person';
import PersonSipoTransferAggregationPage from 'subscription/pages/transfer-other-municipality-family-aggregation/edit-person';
import SubscriptionBirthNonResidentPage from 'shell/components/shared/research-notifications/reasearch-birth-non-resident/birth-non-resident';
import ResearchMarriageNonResidentNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-marriage-non-resident';
import ResearchMarriageNonResidentDetailNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/detail';
import PersonMarriageNonResidentNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person';
import PersonSearchMarriageNonResidentNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person-search';
import ResearchDeathNonResidentNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-death-non-resident';
import ResearchDeathNonResidentDetailNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-death-non-resident/detail';
import PersonSearchDeathNonResidentNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-death-non-resident/edit-person-search';
import ResearchNotificationsCivilStatusRegistryOfficePage from 'subscription/pages/research-registration-civil-status-registry-office/list';
import DetailNotificationsCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/detail';
import EditNotificationsCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/edit';
import ResearchBirthNonResidentNotificationsCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/reasearch-birth-non-resident';
import ResearchCivilUnionNotificationCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/research-civil-union';
import RegistrationCivilUnionDetailNotificationsPage from 'subscription/pages/research-registration-civil-status-registry-office/research-civil-union/detail';
import ResearchCivilUnionNonResidentNotificationCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident';
import PersonSearchCivilUnionNonResidentNotificationCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person-search';
import RegistrationCivilUnionDetailNotificationsCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/detail';
import PersonCivilUnionNonResidentNotificationCivilStatusPage from 'subscription/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person';
import AnscNotificationsBirthNonResidentPage from 'subscription/pages/ansc-notification/birth-non-resident';
import ResearchFamilyNotificationsCivilStatusPage from 'subscription/pages/ansc-notification/research-family/family';
import ResearchFamilyNotificationsFatherDetailCivilStatusPage from 'subscription/pages/ansc-notification/research-family/father/detail';
import ResearchFamilyNotificationsMotherCivilStatusPage from 'subscription/pages/ansc-notification/research-family/mother';
import ResearchFamilyNotificationsDetailCivilStatusPage from 'subscription/pages/ansc-notification/research-family/family/detail';
import ResearchFamilyNotificationsMotherDetailCivilStatusPage from 'subscription/pages/ansc-notification/research-family/mother/detail';
import ResearchFamilyNotificationsFatherCivilStatusPage from 'subscription/pages/ansc-notification/research-family/father';
import ResearchFamilyNotificationsOtherCivilStatusPage from 'subscription/pages/ansc-notification/research-family/other';
import ResearchFamilyNotificationsOtherDetailCivilStatusPage from 'subscription/pages/ansc-notification/research-family/other/detail';
import ResearchCohabitationNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-cohabitation';
import RegisterCohabitationNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-cohabitation/detail';
import ResearchDeathNotificationResidentCivilStatusPage from 'subscription/pages/ansc-notification/research-death';
import CancellationDeathNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-death/detail';
import ResearchDeathNonResidentNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-death-non-resident';
import PersonSearchDeathNonResidentNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-death-non-resident/edit-person-search';
import CancellationNonResidentNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-death-non-resident/detail';
import ResearchMarriageNotificationsCivilStatusPage from 'subscription/pages/ansc-notification/research-marriage';
import ResearchMarriageDetailNotificationsCivilStatusPage from 'subscription/pages/ansc-notification/research-marriage/detail';
import ResearchMarriageNonResidentNotificationsCivilStatusPage from 'subscription/pages/ansc-notification/research-marriage-non-resident';
import PersonSearchMarriageNonResidentNotificationsCivilStatusPage from 'subscription/pages/ansc-notification/research-marriage-non-resident/edit-person-search';
import ResearchMarriageNonResidentDetailNotificationsCivilStatusPage from 'subscription/pages/ansc-notification/research-marriage-non-resident/detail';
import PersonMarriageNonResidentNotificationsCivilStatusPage from 'subscription/pages/ansc-notification/research-marriage-non-resident/edit-person';
import ResearchCivilUnionAnscNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-civil-union';
import RegistrationCivilUnionDetailAnscNotificationPage from 'subscription/pages/ansc-notification/research-civil-union/detail';
import ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-civil-union-non-resident';
import PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-civil-union-non-resident/edit-person-search';
import RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-civil-union-non-resident/detail';
import PersonCivilUnionNonResidentAnscNotificationCivilStatusPage from 'subscription/pages/ansc-notification/research-civil-union-non-resident/edit-person';
import AnscNotificationsPage from 'subscription/pages/ansc-notification/list';
import AnscNotificationsDetailPage from 'subscription/pages/ansc-notification/detail';
import AnscNotificationsEditPage from 'subscription/pages/ansc-notification/edit';
import ResearchCitizenshipAnscNotificationsPage from 'subscription/pages/ansc-notification/research-citizenship';
import RegistrationCitizenshipAnscNotificationsPage from 'subscription/pages/ansc-notification/research-citizenship/detail';
import PersonSipoBornSoloPage from 'subscription/pages/transcription-birth-act-lonely/edit-person';
import PersonSipoBornAggregazionePage from 'subscription/pages/transcription-birth-act-family-aggregation/edit-person';
import ForeignResidencePage from 'subscription/pages/foreign-residence';
import PersonSipoForeignResidencePage from 'subscription/pages/foreign-residence/edit-person';

export const subscriptionRoutes = [
  {
    path: '',
    element: <WrapperPersonSearch />,
    children: [
      {
        path: '',
        name: 'Iscrizioni',
        element: <HomePage />,
      },
      {
        path: '/famiglia',
        authorizations: SubscriptionBirth,
        name: 'Registrazione Nascita in Famiglia',
        children: [
          {
            path: '',
            element: <FamilyPage />,
          },
          {
            path: '/nascita',
            element: <SubscriptionBirthPage />,
          },
        ],
      },
      {
        path: '/non-residenti',
        children: [
          {
            path: '/nascita',
            element: <SubscriptionBirthNonResidentPage />,
          },
        ],
        element: <Outlet />,
      },
      {
        path: '/convivenza',
        authorizations: SubscriptionBirth,
        name: 'Registrazione Nascita in Convivenza',
        children: [
          {
            path: '',
            element: <FamilyPageCohabitation />,
          },
          {
            path: '/nascita',
            element: <SubscriptionBirthCohabitationPage />,
          },
        ],
      },
      {
        path: '/convivenza',
        authorizations: SubscriptionBirth,
        name: 'Registrazione Nascita in Convivenza',
        children: [
          {
            path: '',
            element: <FamilyPageCohabitation />,
          },
          {
            path: '/nascita',
            element: <SubscriptionBirthCohabitationPage />,
          },
        ],
      },
      {
        path: '/residenza/estero',
        authorizations: SubscriptionAire,
        name: "Iscrizione AIRE per accertata residenza all'estero",
        children: [
          {
            path: '',
            element: <ForeignResidencePage />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoForeignResidencePage />,
          },
        ],
      },
      {
        path: '/aire-nascita-solo',
        authorizations: SubscriptionAire,
        name: 'Iscrizione AIRE atto di nascita - Solo',
        children: [
          {
            path: '',
            element: <BornSolo />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoBornSoloPage />,
          },
        ],
      },
      {
        path: '/aire-nascita-aggregazione',
        authorizations: SubscriptionAire,
        name: 'Iscrizione AIRE atto di nascita - Aggregazione',
        children: [
          {
            path: '',
            element: <BornAggregazioneSearch />,
          },
          {
            path: '/trascrizione',
            element: <BornAggregazione />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoBornAggregazionePage />,
          },
        ],
      },
      {
        path: '/aire-trasferimento-nuova',
        authorizations: SubscriptionAire,
        name: 'Iscrizione AIRE per trasferimento - Nuova famiglia',
        children: [
          {
            path: '',
            element: <TransferNewSearch />,
          },
          {
            path: '/trasferimento',
            element: <TransferNew />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoTransferNewPage />,
          },
        ],
      },
      {
        path: '/aire-trasferimento-aggregazione',
        authorizations: SubscriptionAire,
        name: 'Iscrizione AIRE per trasferimento - Aggregazione a famiglia',
        children: [
          {
            path: '',
            element: <TransferAggregationSearch />,
          },
          {
            path: '/trasferimento',
            element: <TransferAggregation />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoTransferAggregationPage />,
          },
        ],
      },
      {
        path: '/aire-cittadinanza-nuova',
        authorizations: SubscriptionAire,
        name: 'Iscrizione AIRE per acquisto cittadinanza - Nuova famiglia',
        children: [
          {
            path: '',
            element: <CitizenshipNew />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoCitizenshipNewPage />,
          },
        ],
      },
      {
        path: '/aire-cittadinanza-aggregazione',
        authorizations: SubscriptionAire,
        name: 'Iscrizione AIRE per acquisto cittadinanza - Aggregazione a famiglia',
        children: [
          {
            path: '',
            element: <CitizenshipAggregationSearch />,
          },
          {
            path: '/persona-sipo',
            element: <PersonSipoPage />,
          },
          {
            path: '/acquisto',
            element: <CitizenshipAggregation />,
          },
        ],
      },
      {
        path: '/notifiche-da-stato-civile',
        element: <PageResearchNotificationsInitizializer />,
        children: [
          {
            path: '',
            element: <ResearchNotificationsCivilStatusRegistryOfficePage />,
          },
          {
            path: '/visualizza/:id/:idNotifica',
            element: <DetailNotificationsCivilStatusPage />,
          },
          {
            path: '/modifica/:id/:idNotifica',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <EditNotificationsCivilStatusPage />,
              },
              {
                path: '/nascita',
                element: <Outlet />,
                children: [
                  {
                    path: '/non-residenti',
                    element: <ResearchBirthNonResidentNotificationsCivilStatusPage />,
                  },
                ],
              },
              {
                path: '/famiglia',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/madre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsMotherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsMotherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/padre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsFatherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsFatherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/altra',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsOtherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsOtherDetailPage />,
                  },
                ],
              },
              {
                path: '/convivenza',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchCohabitationNotificationsPage />,
                  },
                  {
                    path: '/nascita',
                    element: <ResearchCohabitationNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/morte',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNotificationsPage />,
                      },
                      {
                        path: '/cancellazione',
                        element: <CancellationDeathNotificationPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/cancellazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNonResidentDetailNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/matrimonio',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNotificationsPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <ResearchMarriageDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNonResidentDetailNotificationsPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonMarriageNonResidentNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/unione-civile',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <RegistrationCivilUnionDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <RegistrationCivilUnionDetailNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonCivilUnionNonResidentNotificationCivilStatusPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '/notifiche',
        element: <Outlet />,
        children: [
          {
            path: '/ansc',
            element: <PageResearchNotificationsInitizializer />,
            children: [
              {
                path: '',
                element: <AnscNotificationsPage />,
              },
              {
                path: '/visualizza/:id/:idNotifica',
                element: <AnscNotificationsDetailPage />,
              },
              {
                path: '/modifica/:id/:idNotifica',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <AnscNotificationsEditPage />,
                  },
                  {
                    path: '/cittadinanza/ricerca',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCitizenshipAnscNotificationsPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <RegistrationCitizenshipAnscNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/nascita',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/non-residenti',
                        element: <AnscNotificationsBirthNonResidentPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/madre',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsMotherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsMotherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/padre',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsFatherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsFatherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/altra',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsOtherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsOtherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/convivenza',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCohabitationNotificationCivilStatusPage />,
                      },
                      {
                        path: '/nascita',
                        element: <RegisterCohabitationNotificationCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/morte',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNotificationResidentCivilStatusPage />,
                          },
                          {
                            path: '/cancellazione',
                            element: <CancellationDeathNotificationCivilStatusPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNonResidentNotificationCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonSearchDeathNonResidentNotificationCivilStatusPage />,
                          },
                          {
                            path: '/cancellazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: <CancellationNonResidentNotificationCivilStatusPage />,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: '/matrimonio',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/registrazione',
                            element: <ResearchMarriageDetailNotificationsCivilStatusPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNonResidentNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: (
                              <PersonSearchMarriageNonResidentNotificationsCivilStatusPage />
                            ),
                          },
                          {
                            path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: (
                                  <ResearchMarriageNonResidentDetailNotificationsCivilStatusPage />
                                ),
                              },
                              {
                                path: '/persona-sipo',
                                element: <PersonMarriageNonResidentNotificationsCivilStatusPage />,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: '/unione-civile',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchCivilUnionAnscNotificationCivilStatusPage />,
                          },
                          {
                            path: '/registrazione',
                            element: <RegistrationCivilUnionDetailAnscNotificationPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: (
                              <ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage />
                            ),
                          },
                          {
                            path: '/persona-sipo',
                            element: (
                              <PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage />
                            ),
                          },
                          {
                            path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: (
                                  <RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage />
                                ),
                              },
                              {
                                path: '/persona-sipo',
                                element: (
                                  <PersonCivilUnionNonResidentAnscNotificationCivilStatusPage />
                                ),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
